// src/components/Header.jsx
import React from "react";
import { Link, NavLink } from "react-router-dom";

const baseLink =
  "text-xs sm:text-sm font-medium text-neutral-200/80 hover:text-white transition-colors";

function navClasses({ isActive }) {
  return baseLink + (isActive ? " text-white" : "");
}

export default function Header() {
  return (
    // NOTE: removed "sticky top-0". Now it's just a normal header.
    <header className="bg-black/95 backdrop-blur border-b border-neutral-800">
      <div className="mx-auto max-w-7xl px-4 py-3">
        <div className="relative flex flex-col gap-3 sm:flex-row sm:items-center">
  
  {/* LEFT: nav links */}
  <nav className="order-2 sm:order-1 flex justify-center sm:justify-start gap-4 sm:gap-6">
    <NavLink to="/products" className={navClasses}>Products</NavLink>
    <NavLink to="/gallery" className={navClasses}>Gallery</NavLink>
    <NavLink to="/packages" className={navClasses}>Dealer Sign Up</NavLink>
    <NavLink to="/dealer-map" className={navClasses}>Preferred Dealer Map</NavLink>
  </nav>

  {/* CENTER: logo */}
<div className="order-1 sm:order-2 flex justify-center mb-2 sm:mb-0 sm:block sm:absolute sm:left-1/2 sm:-translate-x-1/2">
  <Link to="/" className="inline-flex items-center">
    <img
      src="/assets/ulwraps-logo-main.png"
      alt="UL Wraps"
      className="h-14 sm:h-16 md:h-20 w-auto"
    />
  </Link>
</div>

  {/* RIGHT: Browse Colors */}
  <div className="order-3 flex justify-center sm:justify-end sm:ml-auto">
    <Link
      to="/colors"
      className="inline-flex items-center rounded-full bg-white text-black px-4 py-2 text-xs sm:text-sm font-semibold shadow-md hover:bg-neutral-200 transition"
    >
      Browse Colors
    </Link>
  </div>
</div>
      </div>
    </header>
  );
}
